module.exports = __webpack_public_path__ + "img/Frame.e916dea4.svg";